import React from 'react';

interface InAppLinkProps {
    /** The app path the link goes to, e.g. `/connect`. */
    href: string;
    /** Runs on a plain click, in place of a page load: the caller moves the
     *  router (`navigateToView`) and closes whatever the link sits in. Without
     *  it the browser follows `href` as usual. */
    onNavigate?: () => void;
    className?: string;
    children: React.ReactNode;
}

/**
 * A link to a page of this app that opens without a reload.
 *
 * It is a real `<a href>`, so assistive technology reads it as a link and a
 * modified click (new tab, new window) still works. It needs no router
 * context, so dialog copy that is built outside the route tree can use it.
 */
export default function InAppLink({ href, onNavigate, className, children }: InAppLinkProps) {
    return (
        <a
            href={href}
            className={className}
            onClick={(event) => {
                if (!onNavigate) return;
                if (
                    event.defaultPrevented
                    || event.button !== 0
                    || event.metaKey
                    || event.ctrlKey
                    || event.shiftKey
                    || event.altKey
                ) {
                    return;
                }
                event.preventDefault();
                onNavigate();
            }}
        >
            {children}
        </a>
    );
}
